import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    uploadFile: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            uploadFile: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectNavigation_ContextMenu.uploadFile?c=2r2ily5gfaabg", defaultMessage: "Upload Asset" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
